import "../../../../shared/lib/store/createAppApi.js";
import "../../../../shared/lib/store/createAppAsyncThunk.js";
import { createAppSelector } from "../../../../shared/lib/store/createAppSelector.js";
import "../../../../shared/lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../shared/lib/store/hooks/useAppStore.js";
import "../../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../../shared/store/config/model/selectors/selectFilterGrid.js";
import { selectFilterGridItems } from "../../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../../shared/store/config/model/selectors/selectModels.js";
import "../../../../shared/store/config/model/selectors/selectSort.js";
import "../../../../shared/store/config/model/selectors/selectTags.js";
import "../../../../shared/store/config/model/selectors/selectTradeIn.js";
import "@perxis-auto/shared";
import { getDependentFilterKeysByKey } from "../../lib/filterDependency/getDependentFilterKeysByKey.js";
const selectDependentFilterKeysByKey = createAppSelector(
  [(_, { filterKey }) => filterKey, selectFilterGridItems],
  (filterKey, filterGridItems) => {
    return getDependentFilterKeysByKey(filterKey, filterGridItems);
  }
);
export {
  selectDependentFilterKeysByKey
};
